import { Component, Input } from "@angular/core";
import { ShipmentBox, ShipmentBoxItem } from "../../Dto/ShipmentModel";

@Component({
  selector: "app-shipment-box-expanded-row",
  standalone: true,
  templateUrl: "./ShipmentBoxExpandedRowComponent.html",
  styleUrl: "./ShipmentBoxExpandedRowComponent.scss",
})
export class ShipmentBoxExpandedRowComponent {
  @Input({ required: true }) box!: ShipmentBox;

  get items(): ShipmentBoxItem[] {
    return this.box?.items ?? [];
  }

  getPackedLineCount(): number {
    return this.items.length;
  }

  getPackedQty(): number {
    return this.items.reduce((sum, item) => sum + Number(item.qty ?? 0), 0);
  }

  getPackedLineSuffix(): string {
    if (this.getPackedLineCount() === 1) {
      return "";
    }
    return "s";
  }

  getRequestCount(): number {
    return new Set(this.items.map((item) => item.requestId).filter(Boolean)).size;
  }

  getOwnerCount(): number {
    return new Set(this.items.map((item) => item.ownerName).filter(Boolean)).size;
  }
}
